import DriverTdsCertificates from "../../../views/DriverTdsCertificates";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverTdsCertificatesRoutes = [
  {
    path: "/driver-tds-certificates",
    component: DriverTdsCertificates,
    exact: true,
    menuName: MenuNames.DRIVER_TDS_CERTIFICATES,
  },
];

export default DriverTdsCertificatesRoutes;
